import { createIcon } from '../createIcon.tsx';

export const CheckIcon = createIcon('CheckIcon', <polyline points="20 6 9 17 4 12" />);
